import React, { useEffect, useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust path if needed
import JMJButton from '../JMJButton';

const StaffInfoModal = ({
  viewStaffUser,
  showPassword,
  setShowPassword,
  onClose,
  formatPhoneNumber,
  userIsSuperstaff,
  fetchData, // new prop
}) => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    password: '',
    SMSlist: false,
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (viewStaffUser) {
      setForm({
        firstName: viewStaffUser.firstName || '',
        lastName: viewStaffUser.lastName || '',
        phone: viewStaffUser.phone?.toString() || '',
        password: viewStaffUser.password || '',
        SMSlist: !!viewStaffUser.SMSlist,
      });
    }
  }, [viewStaffUser]);

  const handleSave = async () => {
    if (!viewStaffUser) return;
    setSaving(true);
    try {
      const staffId = viewStaffUser.id;
      await updateDoc(doc(db, 'clients', staffId), {
        firstName: form.firstName,
        lastName: form.lastName,
        phone: form.phone.toString(),
        password: form.password,
        SMSlist: form.SMSlist,
      });
      // refresh parent data
      if (typeof fetchData === 'function') {
        await fetchData();
      }
      alert('Staff user updated.');
      onClose();
    } catch (e) {
      console.error('Failed to update staff user:', e);
      alert('Update failed.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg w-[90%] max-w-md text-black">
        <h2 className="text-2xl font-bold mb-4">Staff Info</h2>
        <div className="grid grid-cols-1 gap-4 mb-4">
          <div className="flex flex-col">
            <label className="text-sm font-semibold">First Name</label>
            {userIsSuperstaff ? (
              <input
                className="border border-gray-300 rounded px-2 py-1"
                value={form.firstName}
                onChange={e => setForm(f => ({ ...f, firstName: e.target.value }))}
              />
            ) : (
              <div className="bg-gray-100 border border-gray-300 rounded px-2 py-1">
                {form.firstName || '—'}
              </div>
            )}
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Last Name</label>
            {userIsSuperstaff ? (
              <input
                className="border border-gray-300 rounded px-2 py-1"
                value={form.lastName}
                onChange={e => setForm(f => ({ ...f, lastName: e.target.value }))}
              />
            ) : (
              <div className="bg-gray-100 border border-gray-300 rounded px-2 py-1">
                {form.lastName || '—'}
              </div>
            )}
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Phone</label>
            {userIsSuperstaff ? (
              <input
                className="border border-gray-300 rounded px-2 py-1"
                value={form.phone}
                onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
              />
            ) : (
              <div className="bg-gray-100 border border-gray-300 rounded px-2 py-1">
                {formatPhoneNumber(form.phone)}
              </div>
            )}
          </div>
          <div className="flex items-center gap-2">
            {userIsSuperstaff ? (
              <>
                <input
                  type="checkbox"
                  checked={form.SMSlist}
                  onChange={e => setForm(f => ({ ...f, SMSlist: e.target.checked }))}
                />
                <label className="text-sm">SMS List (receive text messages when Clients create/cancel/reschedule appointments or message JMJ)</label>
              </>
            ) : (
              <>
                <span className="font-semibold text-sm">SMS List:</span>
                <span className="text-sm">{form.SMSlist ? 'Yes' : 'No'}</span>
              </>
            )}
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold">Password</label>
            <div className="relative">
              {userIsSuperstaff ? (
                <div className="flex items-center gap-2">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={form.password}
                    onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                    className="border border-gray-300 rounded px-2 py-1 flex-1"
                  />
                  <button
                    onClick={() => setShowPassword(p => !p)}
                    className="text-sm underline"
                    type="button"
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </button>
                </div>
              ) : (
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={form.password}
                    readOnly
                    className="bg-gray-100 border border-gray-300 rounded px-2 py-1 w-full pr-10"
                  />
                  <button
                    onClick={() => setShowPassword(p => !p)}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-sm underline"
                    type="button"
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <JMJButton text="Close" color="gray" onClick={onClose} disabled={saving} />
          {userIsSuperstaff && (
            <JMJButton text="Save" color="green" onClick={handleSave} disabled={saving} />
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffInfoModal;
